import type { FulfillmentStepKind, OrderFulfillmentDto } from "client/api-v2";

/**
 * Stubbed: there is no backend route left to call this against, so it always throws. Kept so
 * {@link FulfilmentPanel} still compiles and reads as it did.
 * @param _fulfillmentId
 * @param _step
 * @param _details
 */
export async function completeFulfilmentStep(
  _fulfillmentId: string,
  _step: FulfillmentStepKind,
  _details?: string
): Promise<OrderFulfillmentDto> {
  throw new Error("Completing a fulfilment step is not supported: no backend route exists for it.");
}

/**
 * Stubbed for the same reason as {@link completeFulfilmentStep}.
 * @param _fulfillmentId
 * @param _step
 * @param _reason
 */
export async function reopenFulfilmentStep(
  _fulfillmentId: string,
  _step: FulfillmentStepKind,
  _reason: string
): Promise<OrderFulfillmentDto> {
  throw new Error("Reopening a fulfilment step is not supported: no backend route exists for it.");
}
